import { render, staticRenderFns } from "./aboutpij_quotes.vue?vue&type=template&id=1a937a72"
import script from "./aboutpij_quotes.vue?vue&type=script&lang=js"
export * from "./aboutpij_quotes.vue?vue&type=script&lang=js"
import style0 from "./aboutpij_quotes.vue?vue&type=style&index=0&id=1a937a72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports